import MaterialAccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export function AccordionSummary(props: AccordionSummaryProps) {
    return (
        <MaterialAccordionSummary
            data-testid={'AccordionSummary-container'}
            expandIcon={<ExpandMoreIcon />}
            {...props}
        />
    );
}

export default AccordionSummary;
